import ExploreToken from "./ExploreToken";

export default ExploreToken;
